import React, { useCallback, useEffect, useState } from "react";
import * as Scrivito from "scrivito";
import { Collapse } from "reactstrap";
import NiceModal from "@ebay/nice-modal-react";
import cx from "classnames";
import { ProductListModal } from "components/_Modals/ProductListModal";
import { nodeTypes } from "variables";
import { ConfigurationItem } from "components/SummaryListItem/ConfigurationItem";
import { Icon } from "components/Icon/Icon";
import { SummaryListItemIconBtn } from "components/SummaryListItem/SummaryListItemIconBtn";

import styles from "components/SummaryListItem/SummaryListItem.module.scss";
import {
  useSelectedTopologyItemId,
  useSubType,
} from "objs/_ConfiguratorObjs/Wizard/stores/wizardStore";

export const WizardSumarryItem = Scrivito.connect(
  ({
    isAllCollapsed,
    nodes,
    title,
    isTopology,
    handleToggle,
    type,
    ...rest
  }) => {
    const [isOpen, setIsOpen] = useState(true);
    const selectedTopologyItemId = useSelectedTopologyItemId();
    const subType = useSubType();

    const {
      isOpen: openParent,
      hasChildren,
      id,
      orderCode,
      dummy,
      setSideBarId,
      menu,
      groupPosition,
    } = rest;

    const handleBackAction = useCallback(() => {
      NiceModal.show(ProductListModal, {
        id,
        orderCode,
        dummy,
        wizardType: subType,
        title,
        type,
        handleBackAction,
      });
    }, [id, orderCode, dummy, subType, title, type]);

    useEffect(() => {
      isAllCollapsed && setIsOpen(isAllCollapsed.description === "true");
    }, [isAllCollapsed]);

    const handleToggleDetails = useCallback(() => setIsOpen((val) => !val), []);

    const handleItemClick = useCallback(
      (e) => {
        e.stopPropagation();
        isTopology && setSideBarId(id);
      },
      [id, isTopology, setSideBarId],
    );

    return (
      <>
        {nodes || isTopology ? (
          <>
            <div
              className={cx(
                "d-flex  justify-content-between align-items-center border-bottom ms-2",
                styles.item,
                {
                  "bg-gray-100":
                    isTopology && selectedTopologyItemId === rest.id,
                },
              )}
              onClick={handleItemClick}
            >
              <div className="d-flex align-items-center">
                {isTopology && hasChildren ? (
                  <Icon
                    onClick={handleToggle}
                    iconName={
                      openParent ? "fa-chevron-down" : "fa-chevron-right"
                    }
                    className="icon-16 ms-1 me-3 cursor-pointer"
                  />
                ) : (
                  nodes && (
                    <>
                      {nodes.length > 0 ? (
                        <>
                          <Icon
                            onClick={handleToggleDetails}
                            iconName={
                              isOpen ? "fa-chevron-down" : "fa-chevron-right"
                            }
                            className="icon-16 ms-1 me-3 cursor-pointer"
                          />
                        </>
                      ) : (
                        <div className={cx("ms-1", styles.noNodes)} />
                      )}
                    </>
                  )
                )}
                {isTopology && !hasChildren && <div className="px-2_5" />}
                {isTopology ? (
                  <div className="w-80 d-flex flex-column">
                    <div className="fw-bolder fs-md">{title}</div>
                    <div
                      className={cx("text-truncate", {
                        "text-warning": rest.presentation === "Dummy",
                        "text-gray-400": rest.presentation !== "Dummy",
                      })}
                    >
                      {rest.presentation}
                    </div>
                    <div className="d-flex flex-nowrap fs-sm text-gray-400">
                      {rest.selectedAccessories?.map((item, key) => (
                        <div className="me-3" key={key}>
                          {item.currentPresentation}
                        </div>
                      ))}
                    </div>
                  </div>
                ) : (
                  <div className="fw-bolder fs-md">{title}</div>
                )}
              </div>
              <div className="d-flex flex-nowrap w-20 h-auto">
                {isTopology &&
                  menu?.map((item, key) => (
                    <SummaryListItemIconBtn
                      type={type}
                      key={key}
                      menuItem={item}
                      {...rest}
                      title={title}
                      handleBackAction={handleBackAction}
                      groupPosition={groupPosition}
                    />
                  ))}
              </div>
            </div>
            {nodes && (
              <Collapse className="ms-2_5" isOpen={isOpen}>
                {nodes.map((node) =>
                  node.kind === nodeTypes.CONFIGURATION ? (
                    <ConfigurationItem key={node.id} conf={node} />
                  ) : (
                    <WizardSumarryItem
                      key={node.id}
                      isAllCollapsed={isAllCollapsed}
                      {...node}
                    />
                  ),
                )}
              </Collapse>
            )}
          </>
        ) : (
          <div
            className={cx(
              "d-flex justify-content-between align-items-center border-bottom fw-bolder ps-2_5",
              styles.item,
            )}
          >
            <div className="ms-5 fs-md">{title}</div>
          </div>
        )}
      </>
    );
  },
);
